import React from 'react'
import logo from '../../../../assets/img/layout/navlogo.png'
import DevelopmentTable from 'views/admin/tables/components/DevelopmentTable';
const PreviewInvoice = (props) => {
  const { customerId, customerName, customerMb,customerAddress,gameHost,modeOfTranscation,date,time,gamingTotal, eventsTotal,total,_id,fNbTotal,discountAmount,discountName,products,discounts,games } = props.data
    return (
    <div className='flex justify-center'>    
    <div className=' mt-3 rounded-primary bg-white container p-5 md-max:text-base dark:border-navy-900 dark:bg-navy-800'>
        <div className='flex justify-center' >
            <img src={logo} className='h-20 p-2'/>
        </div>
        <div className='text-6xl mt-4 text-brand-500 font-semibold'>
            Invoice
        </div>
        <div className='mt-5 flex justify-between flex-wrap '>
            <div >
            <span className='text-xl text-navy-800 font-semibold  dark:text-white'>Invoice For:</span><br/>
                <div className='text-navy-700 font-medium dark:text-gray-500 '>
                {customerName}<br/>
                {customerMb}<br/>
                {customerAddress}            
                </div>
            </div>
            <div >
                <span className='text-xl text-navy-800 font-semibold dark:text-white'>Date:</span><br/>
                <div className='text-navy-700 font-medium dark:text-gray-500'>
                {date}<br/>
            </div>
            <span className='text-xl text-navy-800 font-semibold dark:text-white'>Time:</span><br/>
                <div className='text-navy-700 font-medium dark:text-gray-500'>
                {time}<br/>
                </div>
           
            </div>
            
            <div className=''>
            <span className='text-xl text-navy-800  font-semibold dark:text-white'>Invoice Number:</span><br/>
                <div className='text-navy-700 font-medium dark:text-gray-500'>
               {_id || '#154254252'}<br/>
                </div>
                <span className='text-xl text-navy-800 font-semibold dark:text-white'>Payable to:</span><br/>
                <div className='text-navy-700 font-medium dark:text-gray-500'>
                {gameHost}<br/>
                </div>
           
            </div>
        </div>
        
        {products.filter(elem=>elem.type==='FNB').length>0&&<div className='m-[-15px] mt-4'>   
        <DevelopmentTable columnsData={[
            {
              Header: "DESCRIPTION",
              accessor: "description",
            },
            {
              Header: "UNIT PRICE",
              accessor: "unitPrice",
            },
            {
              Header: "QUANTITY",
              accessor: "qty",
            },
            {
              Header: "TOTAL PRICE",
              accessor: "totalPrice",
            },
          ]}
          tableData={products.filter(elem=>elem.type==='FNB')}
          tableTitle={"Food and Beverages"}
          titleColor={'text-brand-500'}
          />
          <div className='text-right  mr-4 text-navy-900 dark:text-white'><span className='font-medium'>Subtotal : </span><span className='font-semibold'>Rs {fNbTotal}</span></div>
         </div>}
        
        {products.filter(elem=>elem.type==='GAMING').length>0&& <div className=' m-[-15px] mt-4'>
        <DevelopmentTable columnsData={[
            {
              Header: "DESCRIPTION",
              accessor: "description",
            },
            {
              Header: "UNIT PRICE",
              accessor: "unitPrice",
            },
            {
              Header: "QUANTITY",
              accessor: "qty",
            },
            {
              Header: "TOTAL PRICE",
              accessor: "totalPrice",
            },
          ]}
          tableData={products.filter(elem=>elem.type==='GAMING')}
          tableTitle={"Gaming"}
          titleColor={'text-brand-500'}
          />
          <div className='text-right  mr-4 text-navy-900 dark:text-white'><span className='font-medium'>Subtotal : </span><span className='font-semibold'>Rs {gamingTotal}</span></div>
         </div>}

         {products.filter(elem=>elem.type==='EVENTS').length>0&& <div className=' m-[-15px] mt-4'>
        <DevelopmentTable columnsData={[
            {
              Header: "DESCRIPTION",
              accessor: "description",
            },
            {
              Header: "UNIT PRICE",
              accessor: "unitPrice",
            },
            {
              Header: "QUANTITY",
              accessor: "qty",
            },
            {
              Header: "TOTAL PRICE",
              accessor: "totalPrice",
            },
          ]}
          tableData={products.filter(elem=>elem.type==='EVENTS')}
          tableTitle={"Events"}
          titleColor={'text-brand-500'}
          />
          <div className='text-right  mr-4 text-navy-900 dark:text-white'><span className='font-medium'>Subtotal : </span><span className='font-semibold'>Rs {eventsTotal}</span></div>
         </div>}

         {discounts.length>0&& <div className=' m-[-15px] mt-4'>
        <DevelopmentTable columnsData={[
            {
              Header: "DESCRIPTION",
              accessor: "description",
            },
            {
              Header: "UNIT PRICE",
              accessor: "unitPrice",
            },
            {
              Header: "QUANTITY",
              accessor: "qty",
            },
            {
              Header: "TOTAL PRICE",
              accessor: "totalPrice",
            },
          ]}
          tableData={discounts}
          tableTitle={"Adjustments"}
          titleColor={'text-brand-500'}
          />
          <div className='text-right  mr-4 text-navy-900 dark:text-white'><span className='font-medium'>Subtotal : </span><span className='font-semibold'>- Rs {Math.abs(discountAmount)}</span></div>
         </div>}  

        <div className="mt-[31px] text-navy-900 border-t dark:border-navy-900 md-max:text-sm flex justify-between flex-wrap dark:text-white">
            <div className=' mt-4 font-semibold'>
                Notes :
            </div>
            <div className='text-right  mt-4 mr-2 md-max:text-sm '>
                {games.length!=0 && <div><span className='font-medium'>Games : </span><span className='font-semibold'>{games.map(elem=>elem.name).join(",")}</span></div>}
                {/* <span className='font-medium'>Adjustments  border-t mt-2 dark:border-navy-900 pt-2 ({discountName}) : </span><span className='font-semibold'>- Rs {Math.abs(discountAmount)}</span> */}
                <div className='font-bold  text-2xl text-brand-500 md-max:text-xl'>Rs {total}</div>
            </div>            
        </div>  
    </div>
    </div>
  )
}

export default PreviewInvoice
